import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Routes from './../pages/_routes'

import Header from './../components/header'
import Footer from './../components/footer'

import Home from './../pages/home'
import NotFound from './../pages/notfound'

class App extends React.Component {
	render() {
		return (
			<Router>
				<div>
					<Header />
					<Switch>
						<Route exact path="/" component={Home} />
						{Routes.Header.map( (route, index) => {
							return <Route key={index} path={route.path} exact={route.exact} component={route.component} />
						})}
						{Routes.Footer.map( (route, index) => {
							return <Route key={index} path={route.path} exact={route.exact} component={route.component} />
						})}
						<Route component={NotFound} />
					</Switch>
					<Footer />
				</div>
			</Router>
		)
	}
}

export default App


// WEBPACK FOOTER //
// ./src/components/app.js